import store from '@/store'
const utilRegister = function(app) {
  app.prototype.validData = (value, defaultVal = true) => {
    console.log('value: ', value)
    if (value && value instanceof Array) {
      const all_permission = 'admin'
      const permissions = store.getters && store.getters.permissionsList
      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || value.includes(permission)
      })
      console.log('hasPermissions: ', hasPermissions)
      // return premission || defaultVal
      return hasPermissions
    }
    return defaultVal
  }
}

export default utilRegister
